import React from 'react';

const Settings: React.FC = () => {
    return (
        <div>
            <h2>Settings Page</h2>
            <p>Here you can configure your settings.</p>
        </div>
    );
};

export default Settings;
